module.exports = __webpack_public_path__ + "static/media/tip-3.8bcc02e6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/tip-3.jpeg
// module id = 539
// module chunks = 0